import * as React from 'react';
import { SVGProps } from 'react';

const FileIconSvgSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      d="M19 18h-4v1.5h-4.094a1 1 0 1 0-.09 1h2.417a6.715 6.715 0 0 0-2.955 5.568V28H9v4h4v-4h-1.722v-1.932A5.724 5.724 0 0 1 15 20.705V22h4v-1.295a5.724 5.724 0 0 1 3.722 5.363V28H21v4h4v-4h-1.278v-1.932a6.715 6.715 0 0 0-2.955-5.568h2.367a1 1 0 1 0 0-1H19V18Z"
      fill="#fff"
      opacity={0.6}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 10.75c0 .42-.13.733-.39.94-.253.207-.623.31-1.11.31H11v-1h1.45c.18 0 .317-.037.41-.11a.423.423 0 0 0 .14-.34v-.1c0-.3-.143-.45-.43-.45h-.37c-.467 0-.667-.1-.9-.3-.227-.207-.3-.53-.3-.97v-.47c0-.447.087-.767.34-.96.253-.2.667-.3 1.16-.3H14v1h-1.45c-.167 0-.3.04-.4.12-.1.073-.15.183-.15.33v.11c0 .153.043.267.13.34.093.073.21.1.35.1h.15c.447 0 .787.12 1.02.34.233.213.35.533.35.96v.45ZM15 7h1v3h1V7h1v3l-1 2h-1l-1-2V7Zm6.25 5c.293 0 .543-.067.75-.2v.2c0 1-.16 1-1 1h-1.5v1H22a1 1 0 0 0 1-1V7h-2.3c-.58 0-1.01.127-1.29.38-.273.253-.41.66-.41 1.22v1.8c0 .567.137.977.41 1.23.273.247.703.37 1.29.37h.55Zm.59-1.17c-.107.113-.27.17-.49.17h-.6c-.247 0-.433-.057-.56-.17-.127-.113-.19-.273-.19-.48v-1.7c0-.207.063-.367.19-.48.127-.113.313-.17.56-.17H22v2.45c0 .133-.053.26-.16.38Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconSvgSizeM;
